import { applyStyles } from '../utils/applyStyles';
import { animateModal } from '../utils/animateModal';
import { fitContentEvent } from '../context/actions';
var modalMargins = {
  top: 48,
  right: 24,
  bottom: 48,
  left: 24
};
var TRANSITION_DURATION = 300;
export var useModalTransition = function useModalTransition(board, iframeRef) {
  if (!board) {
    return {
      openModalTransition: function openModalTransition() {
        return null;
      },
      closeModalTransition: function closeModalTransition() {
        return null;
      }
    };
  }

  var _board$getBoundingCli = board.getBoundingClientRect(),
      top = _board$getBoundingCli.top,
      left = _board$getBoundingCli.left,
      right = _board$getBoundingCli.right,
      width = _board$getBoundingCli.width,
      height = _board$getBoundingCli.height;

  var realRight = right - width;
  var realBottom = window.innerHeight - (top + height);

  var closeModalTransition = function closeModalTransition() {
    applyStyles(board, {
      transition: 'none',
      position: 'absolute',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0'
    });
    fitContentEvent(iframeRef);
  };

  var openModalTransition = function openModalTransition() {
    applyStyles(board, {
      transition: 'none',
      position: 'fixed',
      top: "".concat(top, "px"),
      right: "".concat(realRight, "px"),
      bottom: "".concat(realBottom, "px"),
      left: "".concat(left, "px")
    });
    animateModal(board, TRANSITION_DURATION, {
      top: top,
      right: realRight,
      bottom: realBottom,
      left: left
    }, modalMargins, function () {
      return fitContentEvent(iframeRef);
    });
  };

  return {
    openModalTransition: openModalTransition,
    closeModalTransition: closeModalTransition
  };
};